/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Add_Method_GoogleInputs */



/**
* | output |
* | --- |
* | "Google account (SSO)" |
*
* @param {Members_Add_Method_GoogleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_add_method_google = /** @type {((inputs?: Members_Add_Method_GoogleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Add_Method_GoogleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Google-Konto (SSO)")
	return /** @type {LocalizedString} */ ("Google account (SSO)")
});